export const ResponseFormatConstant = {
  FORMDATA: 'formdata',
};
